import { render, staticRenderFns } from "./List.vue?vue&type=template&id=729866a2&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=729866a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729866a2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ProgrammsList/List.vue
// module id = null
// module chunks = 